export default __webpack_public_path__ + "img/xkhmLnIK.6576d544.svg";